var isCallable = require('../internals/is-callable');

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : isCallable(it);
};
